<template lang="pug">
  v-layout.box-mis-vales(column)
    PopupAlertMessage(
      @closeAlertPopup="actionPopupMethod"
      :openPopup="popupAlert.openPopup"
      :image="popupAlert.image"
      :title="popupAlert.title"
      :message="popupAlert.message"
      :messageButton="popupAlert.messageButton"
      :buttonClose="popupAlert.buttonClose"
      :imgHeight="popupAlert.imgHeight"
      :imgWidth="popupAlert.imgWidth"
    )
    v-flex(mb-3)
      p.omnesRegular(style="line-height:1.3; margin:0") Revisa los códigos disponible y el historial de tus códigos vencidos
    v-flex(mb-3)
      v-layout.coupon-tabs(row style="gap:25px")
        v-flex
          ButtonSelect(
            :textBottunProp="'Disponible'"
            :activar="flagDisponible"
            @selectButton="methodView"
            :disabledMisValesDisponibles="listCouponsEnabled.length < 1"
            )
        v-flex
          ButtonSelect(
            :textBottunProp="'Vencido'"
            :activar="flagVencido"
            @selectButton="methodView"
            )
    v-flex(style="margin-bottom:2.5em auto;")
      //-v-layout(column style="width:97%; margin: 0 auto; gap:1rem;" v-if="flagDisponible && listCouponsEnabled.length < 1")
        v-flex
          Coupon(
            :info="defaultCoupon"
            :numeroPoliza="poliza.numeroPoliza"
            )
      v-layout(column style="width:97%; margin: 0 auto; gap:1rem;" v-if="flagDisponible && listCouponsEnabled.length > 0")
        v-flex(v-for="(item, index) in listCouponsEnabled" :key="index")
          Coupon(
            :info="item"
            :numeroPoliza="poliza.numeroPoliza"
            )
      v-layout(column style="width:97%; margin: 0 auto; gap:1rem;" v-if="flagVencido")
        v-flex(v-for="(item, index) in listCouponsDisabled" :key="index")
          Coupon(
            :info="item"
            :numeroPoliza="poliza.numeroPoliza"
            )
    v-flex.g-text-center(mt-3 style="font-size:18px; line-height:1.4; color:#454A6C;")
      v-layout(row)
        v-flex(v-if="listCouponsEnabled.length < 1 && !flagVencido && cuponDisponible")
          p(style="font-size: 14px; line-height: 1.3; margin: 0;") Tu código estará disponible en las próximas semanas.
        v-flex(v-if="listCouponsEnabled.length < 1 && !flagVencido && !cuponDisponible")
          p(style="font-size: 14px; line-height: 1.3; margin: 0;") No tienes cupones disponibles.
        v-flex(v-if="flagDisponible && listCouponsEnabled.length > 0")
          p(style="line-height: 1.3; margin: 0;")
            a.omnesMedium(:href="files.guiaAgora" target="_blank") Aquí
            | &nbsp;te explicamos los pasos para hacer el uso del  vale de consumo Agora
</template>

<script>
import Coupon from '@/components/generic/Coupon.vue'
import ButtonSelect from '@/components/generic/ButtonSelect.vue'
import PopupAlertMessage from '../PopupAlertMessage.vue'
import { mapActions } from 'vuex'

export default {
  props: [
    'poliza',
    'taggeo'
  ],
  data () {
    return {
      image: require('@/assets/characters/informa.svg'),
      popupAlert: {
        openPopup: false,
        option: '',
        title: 'Estimado cliente',
        message: '',
        messageButton: 'Entendido',
        buttonClose: false,
        imgHeight: 150,
        imgWidth: 150
      },
      flagDisponible: true,
      flagVencido: false,
      listCouponsEnabled: [],
      listCouponsDisabled: [],
      defaultCoupon: {
        name: 'Promo Vida Cash',
        amount: '200',
        noCode: 'Tu código aparecerá aquí'
      },
      cuponDisponible: false,
      dataVales: [
        // {
        //   id: 1,
        //   name: 'Promo Vida Cash',
        //   amount: '200',
        //   code: '345JJ',
        //   expire: '06/11/2023',
        //   enabled: true
        // }
        // {
        //   id: 2,
        //   name: 'Promo Vida Cash',
        //   amount: '100',
        //   code: 'IS200',
        //   expire: '16/12/2022',
        //   enabled: false
        // }
      ],
      files: {
        guiaAgora: require('@/assets/downloable/guias/guia-vales-agora.pdf')
      }
    }
  },
  mounted () {
    let self = this

    self.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'antiguedad': self.taggeo.antiguedad,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'navegacion': 'Plan',
        'seccion': 'mis vales'
      }
    })

    self.getCupones(self.poliza.numeroPoliza)
      .then((res) => {
        self.dataVales = []
        res.data.cupones.forEach((coupon, index) => {
          const item = {
            id: index + 1,
            name: coupon.descriptionCampaign,
            amount: coupon.amountCoupon,
            code: coupon.codeCoupon,
            expire: coupon.expirationDateCoupon,
            enabled: !coupon.expired
          }
          if (item.enabled) {
            this.listCouponsEnabled.push(item)
          } else {
            this.listCouponsDisabled.push(item)
          }
        })
        if (this.listCouponsEnabled.length === 0) {
          self.validateCupones(self.poliza.numeroPoliza)
            .then((res) => {
              if (res.data.validatePromo && self.isVidaCashPoliza()) {
                self.cuponDisponible = true
              }
            }).catch((e) => { console.log('validateCupones: ', e) })
        }
      }).catch(() => {
        self.validateCupones(self.poliza.numeroPoliza)
          .then((res) => {
            if (res.data.validatePromo && self.isVidaCashPoliza()) {
              self.cuponDisponible = true
            }
          }).catch((e) => { console.log('validateCupones: ', e) })
      })
  },
  methods: {
    ...mapActions('event', ['eventLog']),
    ...mapActions('user', ['getCupones', 'validateCupones']),
    setUserName () {
      let name = this.poliza.cliente.titleName
      return name.charAt(0).toUpperCase() + name.slice(1)
    },
    /**
     * Alineado con MisSegurosDesktop/Mobile: menú Mis vales solo para nombreProducto que incluye VIDACASH.
     * @returns {boolean}
     */
    isVidaCashPoliza () {
      return (this.poliza.nombreProducto || '').includes('VIDACASH')
    },
    actionPopupMethod (action) {
      if (this.flagVencido && action) {
        this.methodView('vencido')
      } else {
        this.methodView('disponible')
      }
      this.popupAlert.openPopup = false
    },
    methodView (item) {
      let self = this
      this.flagVencido = item === 'vencido'
      this.flagDisponible = item === 'disponible' || item === undefined

      // DISPONIBLE
      if (self.flagDisponible) {
      }

      // VENCIDO
      if (self.flagVencido) {
        if (self.listCouponsDisabled.length < 1) {
          self.methodView('disponible')
          this.popupAlert.openPopup = true
          this.popupAlert.buttonClose = true
          this.popupAlert.image = this.image
          this.popupAlert.message = 'Por el momento no cuentas con vales vencidos.'
          this.popupAlert.title = `¡Hola ${this.setUserName()}!`
          this.popupAlert.messageButton = 'Ok'
        }
      }
    }
  },
  components: {
    Coupon,
    ButtonSelect,
    PopupAlertMessage
  }
}
</script>

<style scoped>
.box-mis-vales {
  padding: 1em 2em;
}
.box-mis-vales p,
.box-mis-vales span,
.box-mis-vales a {
  color: var(--text-color);
  font-size: 14px;
}
.coupon-tabs .flex:first-child .box-button-select-formatter {
  align-items: flex-end !important;
}

.coupon-tabs .flex:last-child .box-button-select-formatter {
  align-items: flex-start !important;
}

.v-card__text {
  padding: 17px 27px;
}

.text-bottom {
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/MisVales.vue